var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("b-modal", {
    attrs: {
      title: _vm.T.logoutConfirmationTitle,
      "ok-title": _vm.T.wordsYes,
      "cancel-title": _vm.T.wordsNo,
      "ok-variant": "primary",
      "cancel-variant": "secondary",
      "footer-class": "logout-confirmation-modal",
      "body-class": "p-0",
      static: "",
      lazy: "",
    },
    on: { ok: _vm.confirmLogout },
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }